// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".storyblok-page[data-v-75fdea0e]{position:relative}[data-v-75fdea0e] .storyblok-spacing,[data-v-75fdea0e]+:not(.storyblok-fullwidth){margin:0 auto;max-width:1200px}.scrollhint[data-v-75fdea0e]{bottom:32px;left:50%;position:fixed;transform:translateX(-50%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
